import { css } from "@emotion/react";
import { theme } from "styles/theme";

export const ModalNewsStyle = {
  wrapper: css`
    top: 330px;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 800px !important;

    .ant-modal {
      &-content {
        padding: unset;
      }
      &-header,
      &-footer {
        background-color: #fff;
        border-bottom: 1px solid gray;
        background-color: #e9e9e9;
        margin-bottom: 0;
        margin-top: 0;
      }
      &-footer {
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;

        text-align: center;
        line-height: 80px;
        background-color: #e9e9e9;
        border-top: 1px solid #ccc;
        border-radius: 0 0 5px 5px;

        button {
          background-image: url("https://0kqo9br0eyii.jquut.net/system-requirement/Web.PortalNew/UK254-01/558fa108ac/images/eec4add93f430d9155ce6f857e8edbde.png");
          background-size: 100%;
          background-position: center top;
          width: 119px;
          height: 45.5px;
          cursor: pointer;
          border: none;
          background-color: transparent;
          color: black !important;

          &:hover {
            background-position: bottom;
          }

          span {
            color: black;
            font-size: 15px;
            font-weight: bolder;
          }
        }
      }
      &-title {
        margin: 0;
        color: ${theme.colors.orange[200]};
        font-size: 21px;
        line-height: 60px;
        font-family: inherit;
        font-weight: 500;

        text-align: center;
      }
    }
  `,

  mainContent: css`
    background: url("https://0kqo9br0eyii.jquut.net/system-requirement/Web.PortalNew/UK254-01/558fa108ac/images/8fc0b1adc87eed2490b37b9966e55b7c.jpg");
    ul {
      display: inline-block;
      list-style: none;
      margin: 0;
      padding: 10px 50px;
      max-height: 500px;
      overflow: auto;
      li {
        color: #454545;
        font-size: 13px;
        line-height: 27px;
        list-style: disc;
        white-space: pre-line;
        border-bottom: 1px dashed #999;
      }
    }
  `,
};
